import { Slot } from '@radix-ui/react-slot';
import { cn } from '@/utils/cn';

type ButtonProps = {
  invert?: boolean;
  children: React.ReactNode;
  asChild?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

const baseClassName =
  'block relative px-[1.4em] py-[0.6em] font-bold text-lg rounded-lg disabled:opacity-50 disabled:cursor-not-allowed ';
const colorClassName = 'bg-white text-purple-600';
const invertColorClassName = 'bg-purple-600 text-white';

export const Button = ({
  children,
  className,
  asChild,
  invert = false,
  type,
  ...props
}: ButtonProps) => {
  const Comp = asChild ? Slot : 'button';

  return (
    <Comp
      {...props}
      type={asChild ? undefined : (type ?? 'button')}
      className={cn(
        baseClassName,
        colorClassName,
        invert && invertColorClassName,
        className,
      )}
    >
      {children}
    </Comp>
  );
};
